import FormStepper from 'components/base/form-stepper';
import PageHeaderText from 'components/base/page-header-text';
import useSettingsContext from 'contexts/settings.context/context';
import React, { useState } from 'react';
import AddUserDetails from './add-user-details';
import ReviewUserDetails from './review-user-details';
import { apiService } from 'services/base.service';
import { toast } from 'react-toastify';
import { ToastMessage } from '@cokitchen/cokitchen-components';
import { useNavigate } from 'react-router-dom';
import useDashboardContext from 'contexts/dashboard.context';
import { isValidEmail, isValidPhone } from 'utils/functions';

const AddUsers = () => {
  const { step, setStep, userFormData } = useSettingsContext();
  const [loading, setLoading] = useState(false);
  const { activeStore } = useDashboardContext();
  const navigate = useNavigate();
  function isStepEmpty(data: any): boolean {
    if (data.length === 0) return true;

    for (const user of data) {
      if (!user.first_name || !user.last_name || !user.email || !user.phone_number) {
        return true;
      }

      if (!isValidEmail(user.email)) {
        return true;
      }
      if (!isValidPhone(user.phone_number)) {
        return true;
      }
      if (!user.role || !user.role.id || !user.role.name) {
        return true;
      }
    }
    return false;
  }
  const createUser = async () => {
    setLoading(true);
    const data = {
      store_id: activeStore?.id,
      users_data: userFormData.map((user) => {
        const { phone_number, first_name, last_name, email } = user;

        return { phone_number, first_name, last_name, email, role_id: user.role.id };
      })
    };
    try {
      await apiService.post('user/bulk', { data });
      toast(<ToastMessage type='success' message='Users created successfully' />);
      navigate('/settings/manage-users');
    } catch (err: any) {
      toast(<ToastMessage type='error' message={err.response.data.message} />);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <PageHeaderText title='Add new user' description='Enter user details correctly' />
      <div className='max-w-full'>
        <FormStepper
          disabled={isStepEmpty(userFormData)}
          title=''
          step={step}
          handleConfirmClick={createUser}
          setStep={setStep}
          noOfSteps={2}
          loading={loading}>
          <div>{step === 1 ? <AddUserDetails /> : <ReviewUserDetails />}</div>
        </FormStepper>
      </div>
    </div>
  );
};
export default AddUsers;
